import * as tslib_1 from "tslib";
import * as React from "react";
import axios from "axios";
import { API_URL, ATTACH_SERVER, SITE_URL } from "../../config/urls";
import { toastr } from "react-redux-toastr";
import Regions from "../../components/Global/regions";
import { connect } from "react-redux";
import LikeIco from "../../assets/icon-like.svg";
import CommentIco from "../../assets/icon-comments.svg";
var qs = require("qs");
var SuggestionView = /** @class */ (function (_super) {
    tslib_1.__extends(SuggestionView, _super);
    function SuggestionView(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            loading: false,
            suggestion: {},
            files: [],
        };
        return _this;
    }
    SuggestionView.prototype.componentWillMount = function () {
        this.getSuggestion();
    };
    SuggestionView.prototype.render = function () {
        var sug = this.state.suggestion;
        var regionName = '';
        Regions.regions.forEach(function (r) {
            if (r.guid === sug.region_fias) {
                regionName = r.name;
            }
        });
        if (sug.hasOwnProperty("id")) {
            return (React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-sm-12" },
                    React.createElement("div", { className: "m-portlet" },
                        React.createElement("div", { className: "m-portlet__body" },
                            React.createElement("div", { className: "d-flex flex-row" },
                                React.createElement("div", { className: "flex-grow-1" },
                                    React.createElement("div", null, sug.image && (React.createElement("img", { src: sug.image, alt: "" }))),
                                    React.createElement("span", { className: "m-badge m-badge--wide " + (sug.status === 'new' ? 'm-badge--info' : (sug.status === 'approved' ? 'm-badge--success' : 'm-badge--danger')) }, sug.status === 'new' ? 'На модерации' : (sug.status === 'approved' ? 'Одобрено' : (sug.status === 'declined' ? 'Отклонено' : 'Снято с публикации пользователем'))),
                                    React.createElement("h2", null, sug.title),
                                    React.createElement("div", null,
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435:  "),
                                            " ",
                                            sug.title),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:  "),
                                            " ",
                                            sug.description),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u0421\u0442\u0430\u0442\u0443\u0441:  "),
                                            " ",
                                            sug.status === 'new' ? 'На модерации' : (sug.status === 'approved' ? 'Одобрено' : (sug.status === 'declined' ? 'Отклонено' : 'Снято с публикации пользователем'))),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u0422\u0435\u043C\u0430:  "),
                                            " ",
                                            sug.theme.title),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041F\u043E\u0434\u0442\u0435\u043C\u0430:  "),
                                            " ",
                                            sug.subtheme.title),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u0413\u043E\u0440\u043E\u0434:  "),
                                            " ",
                                            sug.address),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u0420\u0435\u0433\u0438\u043E\u043D:  "),
                                            " ",
                                            regionName),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041E\u0442 \u044D\u043A\u0441\u043F\u0435\u0440\u0442\u0430:  "),
                                            " ",
                                            sug.is_expert ? 'Да' : 'Нет'),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438:  "))),
                                    React.createElement("div", { className: "d-flex flex-row justify-content-between" },
                                        React.createElement("div", { className: "d-flex flex-row justify-content-between align-items-center" },
                                            React.createElement("div", { className: "mr-3" },
                                                " ",
                                                React.createElement("img", { src: LikeIco, alt: "" }),
                                                " ",
                                                sug.count_likes),
                                            React.createElement("div", null,
                                                " ",
                                                React.createElement("img", { src: CommentIco, alt: "" }),
                                                " ",
                                                sug.count_comments,
                                                " ")),
                                        React.createElement("div", { className: "flex-grow-1 justify-content-center center d-flex flex-row align-items-center" },
                                            React.createElement("div", { className: "user__photo", style: { borderRadius: '50%', width: 34,
                                                    height: 34, backgroundImage: "url(" + sug.user.avatar + ")",
                                                    backgroundPosition: 'center center', backgroundSize: 'cover',
                                                    backgroundRepeat: ' no-repeat' } }),
                                            React.createElement("div", { className: "mt-3" }, sug.user.surname + " " + sug.user.name)))),
                                React.createElement("div", { className: "d-flex flex-column" },
                                    sug.status === 'new' && (React.createElement(React.Fragment, null,
                                        React.createElement("button", { type: "button", onClick: this.changeStatus.bind(this, 'approved'), className: "btn btn-success mb-2 m-btn m-btn--custom m-btn--bolder m-btn--uppercase" }, "\u041E\u0434\u043E\u0431\u0440\u0438\u0442\u044C"),
                                        React.createElement("button", { type: "button", onClick: this.changeStatus.bind(this, 'declined'), className: "btn btn-danger mb-2 m-btn m-btn--custom m-btn--bolder m-btn--uppercase" }, "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C"))),
                                    React.createElement("a", { target: "_blank", href: SITE_URL + '/suggests/' + sug.id, className: "btn btn-link" }, "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043D\u0430 \u0441\u0430\u0439\u0442\u0435"))))),
                    sug.comments && sug.comments.map(function (c) { return (React.createElement(React.Fragment, null,
                        c.text,
                        React.createElement("br", null))); }),
                    (this.state.files && this.state.files.length > 0) && (React.createElement(React.Fragment, null,
                        "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u043B\u0435\u043D\u043D\u044B\u0435 \u0444\u0430\u0439\u043B\u044B:",
                        React.createElement("br", null),
                        this.state.files.map(function (f, idx) { return (React.createElement(React.Fragment, null,
                            React.createElement("a", { style: { display: 'contents' }, key: 'file-' + idx, href: f.link, target: '_blank' }, f.name),
                            React.createElement("br", null))); }))))));
        }
        else {
            return React.createElement("div", null, "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
        }
    };
    SuggestionView.prototype.getSuggestion = function () {
        var _this = this;
        this.setState({ loading: true });
        axios.get(API_URL + '/suggestion/' + this.props.match.params.id).then(function (resp) {
            _this.setState({
                suggestion: resp.data.data ? resp.data.data : {},
                loading: false
            }, function () {
                if (_this.state.suggestion && _this.state.suggestion.files && _this.state.suggestion.files.length > 0) {
                    var files_1 = [];
                    _this.state.suggestion.files.forEach(function (fileId) {
                        axios.get(ATTACH_SERVER + '/attach/' + fileId).then(function (r) {
                            if (r.data && r.data.data && r.data.data.link) {
                                files_1.push({ link: r.data.data.link, name: r.data.data.name, size: r.data.data.size });
                                _this.setState({ files: files_1 });
                            }
                        }).catch(function (e) { return console.log(e); });
                    });
                }
            });
        }).catch(function (error) {
            if (error.response && error.response.status === 403) {
                toastr.error('Ошибка', 'У Вас недостаточно прав');
            }
        });
    };
    SuggestionView.prototype.changeStatus = function (status) {
        var _this = this;
        var result = confirm('Вы уверены, что хотите изменить статус предложения?');
        if (result) {
            axios.post(API_URL + '/suggestion/change-status/' + this.props.match.params.id, qs.stringify({
                status: status,
            }), {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.getSuggestion();
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    return SuggestionView;
}(React.Component));
export default connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
}); })(SuggestionView);



//////////////////
// WEBPACK FOOTER
// ./src/views/suggestions/view.tsx
// module id = 533
// module chunks = 0